// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1s7Cw","box":"WorkspacesBox_box__1aFq7","node":"WorkspacesBox_node__pF43x"};